import { Text, TextInput, Box, Tip } from "grommet";
import { useState } from "react";
import { updateStateHandler } from "../Utils/Utils";

const SheetHeader = (props) => {
    const { plantInfo, station, sheetName, 
        sheetDate } = props;
    
    // console.log('props.plantInfo', props.plantInfo)
    const [value, setValue] = useState(props.sheetYear); // state for the year
   
    return ( 
        <Box fill direction="row" background="light-4" pad={{ left: '10px' }}  justify="between" align="center">
            { props.plantInfo !== undefined && props.plantInfo !== null &&
            <Box direction="row-responsive" justify="between"  align="end" >
                {!props.isStation && 
                <Box width="100px">
                    <Text weight="bold" color="brand" size="large">
                    Seedling: 
                    </Text>                    
                </Box>}

                <Box width="100px" >
                    <Text color="brand" alignSelf="start" weight="bold" size="medium" style={{whiteSpace: 'nowrap',}}>
                    Row:&nbsp;{props.plantInfo.Row}
                    </Text>
                </Box>                       

                <Box width="80px" >
                    <Text color="brand" alignSelf="start" weight="bold" size="medium" style={{whiteSpace: 'nowrap',}}>
                    Vine:&nbsp;{props.plantInfo.Column}
                    </Text>
                </Box>

                <Box width="100px" >
                    <Text color="brand" alignSelf="start" weight="bold" size="medium" style={{whiteSpace: 'nowrap',}}>
                    Year:&nbsp;{props.plantInfo.Year}
                    </Text>
                </Box>
            </Box>
            }

            {props.station && (
            <Box width="220px" >
                <Text color="brand" size="large" style={{whiteSpace: 'nowrap',}}>
                Station:&nbsp;
                <strong style={{ fontWeight: 'bold', fontSize: '20px' }}>
                    {props.station.Name === '' ? props.station.Num : props.station.Name}
                </strong>
                </Text>
            </Box>
            )}

            {/* existing sheet
            { props.editMode = true  */}
            <Box width="220px" >
                <Text color="brand"  size="large"  style={{whiteSpace: 'nowrap',}} >
                Date:&nbsp;
                <strong style={{ fontWeight: 'bold', fontSize: '20px' }}>
                    {props.sheetDate}
                </strong>
                </Text>
            </Box>
        </Box> 
    );
};

export default SheetHeader;
